import { render, staticRenderFns } from "./GameHot.vue?vue&type=template&id=0385396a&"
import script from "./GameHot.vue?vue&type=script&lang=js&"
export * from "./GameHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports